<template>
  <div class="pa-4">
    <v-btn v-if="report && isShowPrintBtn" @click="printData" class="print-btn" x-small width="30" height="30"
           color="primary">
      <v-icon x-small>fas fa-print</v-icon>
    </v-btn>
    <div v-if="salaryData" style="margin: 0 auto; width: 90%">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">ФИО</th>
            <th class="text-left">Паспорт</th>
            <th class="text-left">ИНН</th>
            <th class="text-left">Место работы</th>
            <th class="text-left">Дата</th>
            <th class="text-left">Зарплата</th>
            <th class="text-left">Остальные даходы</th>
            <th class="text-left">ИНПС сум</th>
            <th class="text-left">Подоходный налог</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in salaryData" :key="i">
            <td>{{ item.name }}</td>
            <td>{{ item.series_passport }} {{ item.number_passport }}</td>
            <td>{{ item.tin }}</td>
            <td>{{ item.company_name }}</td>
            <td>{{ item.period }}.{{ item.year }}</td>
            <td>{{ item.salary|money }}</td>
            <td>{{ item.other_income|money }}</td>
            <td>{{ item.inps_sum |money }}</td>
            <td>{{ item.salary_tax_sum |money }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="d-flex justify-center align-center" style="height: 90vh" v-if="errorMessage">
      <h3 class="error--text">{{ errorMessage }}</h3>
    </div>
  </div>
</template>

<script>

export default {
  name: "salary-info-tax",
  props: ['creditId'],
  data() {
    return {
      isShowPrintBtn: true,
      report: null,
      errorMessage: null,
      salaryData: []
    }
  },
  methods: {
    setError(e) {
      if (e.response && e.response.data && e.response.data.message) {
        this.errorMessage = e.response.data.message
      }
    },
    printData() {
      this.isShowPrintBtn = false
      this.$nextTick(() => {
        window.print()
        this.isShowPrintBtn = true
      })
    },

    async getReportByCreditId() {
      try {
        this.errorMessage = null
        const {data: {data}} = await this.$http.get(`/admin/credit/katm/salary-info-tax/${this.creditId}`)
        this.report = parseTextToHtml(data)
      } catch (e) {
        this.$setResponseError({error: e})
        this.setError(e)
      }
    },
    async getReportByUser({pnfl, passport_series, passport_number, region_katm_code, district_katm_code, user_phone}) {
      try {
        let formData = {
          pnfl,
          passport_series,
          passport_number,
          user_phone,
          district_katm_code,
          region_katm_code
        }
        const {data: {data}} = await this.$http.post('admin/calculate/katm-salary-tax', formData)
        let parser = new DOMParser();
        this.report = parser.parseFromString(data, "text/xml");
        const rootElement = this.report.documentElement;
        let children = rootElement.childNodes;
        let items = []
        for (let i = 0; i < children.length; i++) {
          let child = children[i];
          let item = {
            pnfl: child.childNodes[0] && child.childNodes[0].tagName === 'pinfl' ? child.childNodes[0].innerHTML : '',
            ns11_code: child.childNodes[1] && child.childNodes[1].tagName === 'ns11_code' ? child.childNodes[1].innerHTML : '',
            company_tin: child.childNodes[2] && child.childNodes[2].tagName === 'company_tin' ? child.childNodes[2].innerHTML : '',
            period: child.childNodes[3] && child.childNodes[3].tagName === 'period' ? child.childNodes[3].innerHTML : '',
            number_passport: child.childNodes[4] && child.childNodes[4].tagName === 'number_passport' ? child.childNodes[4].innerHTML : '',
            year: child.childNodes[5] && child.childNodes[5].tagName === 'year' ? child.childNodes[5].innerHTML : '',
            other_income: child.childNodes[6] && child.childNodes[6].tagName === 'other_income' ? child.childNodes[6].innerHTML : '',
            salary: child.childNodes[7] && child.childNodes[7].tagName === 'salary' ? child.childNodes[7].innerHTML : '',
            prop_income: child.childNodes[8] && child.childNodes[8].tagName === 'prop_income' ? child.childNodes[8].innerHTML : '',
            series_passport: child.childNodes[9] && child.childNodes[9].tagName === 'series_passport' ? child.childNodes[9].innerHTML : '',
            company_name: child.childNodes[10] && child.childNodes[10].tagName === 'company_name' ? child.childNodes[10].innerHTML : '',
            tin: child.childNodes[11] && child.childNodes[11].tagName === 'tin' ? child.childNodes[11].innerHTML : '',
            name: child.childNodes[12] && child.childNodes[12].tagName === 'name' ? child.childNodes[12].innerHTML : '',
            ns10_code: child.childNodes[13] && child.childNodes[13].tagName === 'ns10_code' ? child.childNodes[13].innerHTML : '',
            inps_sum: child.childNodes[14] && child.childNodes[14].tagName === 'inps_sum' ? child.childNodes[14].innerHTML : '',
            salary_tax_sum: child.childNodes[15] && child.childNodes[15].tagName === 'salary_tax_sum' ? child.childNodes[15].innerHTML : '',
          }
          items.push(item);
        }
        this.salaryData = items;
      } catch (e) {
        this.setError(e)
      }

    }
  },
  computed: {
    isReportByCreditId() {
      return !!this.creditId
    }

  },
  async mounted() {
    const {pnfl, passport_series, passport_number, region_katm_code, district_katm_code, user_phone} = this.$route.query
    this.$showLoading()
    if (this.isReportByCreditId) {
      await this.getReportByCreditId()
    } else if (pnfl && passport_number && passport_series && region_katm_code && district_katm_code && user_phone) {
      await this.getReportByUser({
        pnfl,
        passport_series,
        passport_number,
        region_katm_code,
        district_katm_code,
        user_phone
      })
    }
    this.$clearLoading()
  }
}
</script>


<style>
.print-btn {
  left: 70px;
  top: 100px;
  position: absolute;
}

.template {
  display: block;
  min-height: 29cm;
  margin: auto;
  padding: 1.5cm;
}

.temp-h {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}

.temp-h img {
  width: 25%;
  flex-grow: 0;
  flex-shrink: 0;
  object-fit: contain;
}

.temp-h h3 {
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  flex-grow: 1;
  line-height: 1.5;
  color: #004982;
  margin: 0;
  padding: 0;
  width: 1%;
}

.temp-h-sub {
  display: block;
  border: 2px solid #004982;
  border-width: 2px 0;
  padding: 5px 0;
}

.temp-h-sub ul {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding: 0;
  margin: 0;
}

h1.temp-title {
  display: block;
  text-align: center;
  font-size: 12px;
  color: #959595;
  margin: 10px 0px;
}

.temp-table {
  margin-bottom: 20px;
  font-size: 12px;
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
}

.temp-table tr + tr {
  border-top: 1px solid #E5E5E5;
}

.temp-table tr:first-child {

td {
  padding: 10px 0;
}

}

.temp-table tr:last-child {

td {
  padding-bottom: 15px;
}

}


.temp-table td, .temp-table th {
  padding: 4px 5px;
  color: #000;
  line-height: 1;
  vertical-align: middle;
  text-align: center;
  height: 30px;
}


td.temp-table-h {
  color: #000;
  text-align: center;
  font-weight: 500;
  border: none;
}

.temp-table th {
  text-align: center;
  color: #777;
  text-transform: uppercase;
}

.temp-f p {
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #777;
  line-height: 1.5;
}

.temp-table td:first-child {
  text-align: center;
  width: 30px;
}

.temp-table td:last-child {
  text-align: center;
}

.temp-table-footer {
  margin-bottom: 20px;
  border-bottom: 1px;
  font-size: 12px;
  width: 100%;
}

.temp-table-footer, .temp-table-footer td, .temp-table-footer th {
  border-top: 0;
  border-collapse: collapse;
}

.temp-table-footer td, .temp-table-footer th {
  padding: 4px 5px;
  color: #000;
  line-height: 1;
  vertical-align: middle;
  text-align: center;
}

#table_incoms {
  margin-top: 10px;
  margin-bottom: 0;
}


</style>